<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar />
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav
          style="justify-content: flex-start"
          class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating"
        >
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar">
              <span class="navbar-toggler-icon"></span>
            </button>

            <button
              style="
                color: rgba(0, 0, 0, 0.5);
                border-color: rgba(0, 0, 0, 0.1);
              "
              class="btn btn-outline navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span style="padding-top: 0.5em"
                ><i class="fas fa-user-alt"></i><span class="account-div"></span
                ><i class="fas fa-angle-down"></i
              ></span>
            </button>
          </div>
          <div class="d-flex">
            <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-muted mb-0 hover-cursor">&nbsp;Insurance /&nbsp;</p>
            <p class="text-primary mb-0 hover-cursor">Batch Insurance</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ admin }}
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbarDropdown"
                >
                  <a class="dropdown-item link" @click="toPage('/password')">
                    <i class="fas fa-cog"></i
                    ><span class="right-dropdown">Change Password</span></a
                  >
                  <a class="dropdown-item link" @click="handleLogout"
                    ><i class="fas fa-sign-out-alt"></i
                    ><span class="right-dropdown">Logout</span></a
                  >
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <!-- Filter batch Insurance -->
                <div class="row">
                  <div class="container mt-4" style="display: flex">
                    <div class="col" style="padding-left: 0px">
                      <span
                        >Batch
                        <i
                          class="fa fa-question-circle"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Cari dengan menuliskan tanda koma (,) sebagai pemisah subjek/item pencarian"
                        ></i
                      ></span>
                      <input
                        type="text"
                        class="form-control"
                        name="search_order_id"
                        v-model="searchBatchOrder"
                        placeholder="Batch"
                      />
                    </div>
                    <div class="col" style="padding-left: 0px">
                      Vendor Name
                      <input
                        type="text"
                        class="form-control"
                        name="search_order_id"
                        v-model="searchPartnerName"
                        placeholder="Vendor Name"
                      />
                    </div>
                    <div class="col" style="padding-left: 0px">
                      Declare Date (from)
                      <input
                        type="date"
                        class="form-control"
                        name="search_start_rent_to"
                        v-model="searchStartDateDeclare"
                      />
                    </div>
                    <div class="col" style="padding-left: 0px">
                      Declare Date (to)
                      <input
                        type="date"
                        class="form-control"
                        name="search_end_rent_to"
                        v-model="searchEndDateDeclare"
                      />
                    </div>
                    <div class="col" style="padding-left: 0px">
                      Status
                      <multiselect
                        v-model="searchStatus"
                        :options="['All', 'Ongoing', 'Declared']"
                        :allow-empty="true"
                        :select-label="''"
                        :deselect-label="''"
                        placeholder="All"
                        :multiple="false"
                        :close-on-select="true"
                      ></multiselect>
                    </div>
                    <div
                      style="padding-left: 0px; margin-top: 25px"
                      class="col"
                    >
                      <button
                        class="btn btn-primary mr-1"
                        style="width: 46%"
                        @click="setQuery"
                      >
                        Cari
                      </button>
                      <button
                        class="btn btn-outline-primary"
                        style="width: 46%"
                        @click="resetFilter"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
                <!-- End Filter Bacth insurance -->

                <table
                  class="table table-sm table-bordered table-striped table-responsive-sm mt-2"
                >
                  <thead class="">
                    <tr>
                      <!-- <th>
                        <input
                          type="checkbox"
                          @change="selectAllInsurances"
                          :checked="checkIsSelectAll()"
                        />
                      </th> -->
                      <th>Batch</th>
                      <th style="width: 50%">Vendor Name</th>
                      <th>Declare Date</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable == true">
                      <td colspan="9" class="text-center">
                        <img src="~@/assets/images/load-button.gif" />
                      </td>
                    </tr>
                    <tr v-else-if="loadingTable == false && totalData == 0">
                      <td colspan="9" class="text-center">
                        Data not available
                      </td>
                    </tr>
                    <tr
                      v-for="(data, index) in batchInsuranceList"
                      :key="index"
                      v-else
                    >
                      <!-- <div
                        v-if="
                          selectInsurance.length < 25 ||
                          selectInsurance.find(
                            (item) => item.transId == data.transId
                          )
                        "
                      >
                        <td>
                          <input
                            type="checkbox"
                            v-model="selectInsurance"
                            :value="data"
                          />
                        </td>
                      </div>
                      <div v-else>
                        <td>
                          <input
                            type="checkbox"
                            v-model="selectInsurance"
                            :value="data"
                            disabled="true"
                          />
                        </td>
                      </div> -->

                      <td>
                        <router-link
                          :to="{
                            path: '/insurance/batch/' + data.id,
                            query: {
                              page: 1,
                              itemPerPage: 10,
                            },
                          }"
                        >
                          {{ data.label }}
                        </router-link>
                      </td>
                      <td style="text-align: start">{{ data.partnerName }}</td>
                      <td>
                        <div v-if="data.declaredDate">
                          {{ dateFormat(data.declaredDate) }}
                        </div>
                        <div v-else>-</div>
                      </td>
                      <td>
                        <div
                          class="d-flex justify-content-center text-capitalize"
                          v-if="data.status.toLowerCase() === 'ongoing'"
                        >
                          <div
                            class="badge font-weight-normal badge-pill"
                            style="
                              width: fit-content;
                              color: #3098f7;
                              background: #eaf5fe;
                              padding: 0.5rem;
                            "
                          >
                            {{ data.status }}
                          </div>
                        </div>
                        <div class="d-flex justify-content-center" v-else>
                          <div
                            class="badge font-weight-normal text-capitalize badge-pill"
                            style="
                              width: fit-content;
                              color: #00aa13;
                              background: rgba(0, 170, 19, 0.1);
                              padding: 0.5rem;
                            "
                          >
                            {{ data.status }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-center">
                          <button
                            v-if="data.status.toLowerCase() === 'declared'"
                            class="btn btn-sm btn-action btn-action-download"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Download bukti deklarasi"
                            @click="downloadProvenFile(data)"
                          >
                            <img src="~@/assets/icon/download.svg" />
                          </button>
                          <button
                            v-if="data.status.toLowerCase() === 'ongoing'"
                            class="btn btn-sm btn-action btn-action-trash"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Delete"
                            @click="showConfirmBatchDelete(data.id)"
                          >
                            <img src="~@/assets/icon/trash.svg" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div id="wrapperr">
                  <div id="c1" style="display: inline-flex">
                    <div style="margin-right: 10px">
                      <select
                        class="form-control form-control-sm"
                        v-model="itemPerPage"
                        @change="setQuery()"
                      >
                        <option value="10">10</option>
                        <option value="40">40</option>
                        <option value="80">80</option>
                      </select>
                    </div>
                    <div class="alignLeft total-data">
                      Total Data {{ totalData }}
                    </div>
                  </div>
                  <div id="c2">
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a
                          class="is-active link"
                          @click="toDataPage(parseInt(currentPage) - 1)"
                          v-if="currentPage != 1"
                        >
                          <li>
                            {{ "<" }}
                          </li>
                        </a>
                        <a class="page">
                          <li>{{ currentPage }} of {{ totalPage }} page</li>
                        </a>
                        <a
                          class="is-active link"
                          @click="toDataPage(parseInt(currentPage) + 1)"
                          v-if="currentPage != totalPage"
                        >
                          <li>></li>
                        </a>
                      </ul>
                    </div>
                  </div>
                </div>
                ​
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
      <!-- Start Modal -->
      <div
        class="modal fade"
        id="modalDeleteBatchReason"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          style="width: 650px"
        >
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Delete Reason</h4>
              </div>
            </div>
            <div class="modal-body">
              <div class="container">
                <div class="mt-4">
                  <textarea
                    class="form-control"
                    :class="{
                      'form-control border-red': $v.deleteReason.$error,
                    }"
                    rows="3"
                    placeholder="Berikan penjelasan anda"
                    v-model.trim="$v.deleteReason.$model"
                  ></textarea>
                  <div style="float: right">
                    {{ deleteReason.length }}/{{ maxDeleteReasonLength }}
                  </div>
                  <div
                    style="color: red; font-size: 12px"
                    v-if="$v.deleteReason.$error && !$v.deleteReason.required"
                  >
                    Delete reason is required.
                  </div>
                  <div
                    style="color: red; font-size: 12px"
                    v-if="$v.deleteReason.$error && !$v.deleteReason.minLength"
                  >
                    Delete reason must have at least
                    {{ $v.deleteReason.$params.minLength.min }} letters.
                  </div>
                  <div
                    style="color: red; font-size: 12px"
                    v-if="$v.deleteReason.$error && !$v.deleteReason.maxLength"
                  >
                    Delete reason must have less than
                    {{ $v.deleteReason.$params.maxLength.max }} letters.
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-sm btn-danger"
                @click="closeDeleteBatchReasonModal"
              >
                Batal
              </button>
              <button class="btn btn-sm btn-primary" @click="validateReason">
                Simpan
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import swal from "sweetalert";
import SideBar from "../SideBar";
import { Money } from "v-money";
import Swal from "sweetalert2";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
export default {
  name: "insuranceBatchListPage",
  components: {
    SideBar,
    Multiselect,
    Money,
  },
  data() {
    return {
      loadingTable: false,
      source: "",
      admin: "",
      permission: [],
      deleteReason: "",
      batchDeleteId: 0,
      maxDeleteReasonLength: 144,
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      itemPerPage: this.$route.query.itemPerPage
        ? this.$route.query.itemPerPage
        : 10,
      batchInsuranceList: [],
      searchBatchOrder: "",
      searchPartnerName: "",
      searchStatus: "",
      searchStartDateDeclare: "",
      searchEndDateDeclare: "",
      searchPartnerId: "",
      insuranceStatusSelect: [
        {
          statusAll: "All",
          libs: [
            {
              status: "0",
              statusName: "Pending",
            },
            {
              status: "1",
              statusName: "Issued",
            },
            {
              status: "2",
              statusName: "Not Issued",
            },
            {
              status: "3",
              statusName: "Finished",
            },
            {
              status: "4",
              statusName: "Duplicate LP",
            },
            {
              status: "5",
              statusName: "Duplicate SN",
            },
            {
              status: "replace",
              statusName: "Unit Replaced",
            },
          ],
        },
      ],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      selectInsurance: [],
      token: localStorage.getItem("jwt"),
      password: "",
      disableSave: false,
      cancelInsurancePermission: false,
      canRedeclare: false,
    };
  },
  validations: {
    deleteReason: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(144),
    },
  },
  methods: {
    getListBatchInsurance() {
      this.loadingTable = true;
      const payload = {
        batchOrder: this.$route.query.batchOrder,
        status:
          this.$route.query.status === "All"
            ? ""
            : this.$route.query.status.toLowerCase(),
        startDateDeclare: this.$route.query.startDateDeclare,
        endDateDeclare: this.$route.query.endDateDeclare,
        partnerName: this.$route.query.partnerName,
        page: Number(this.$route.query.page),
        itemPerPage: Number(this.$route.query.itemPerPage),
      };
      this.$http
        .post(process.env.GET_LIST_BATCH_INSURANCE, payload, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          this.loadingTable = false;
          this.batchInsuranceList = response.data.data.data;
          this.totalData = response.data.data.totalData;
          this.totalPage = response.data.data.totalPage;
          this.currentPage = response.data.data.currentPage;
          this.loadingTable = false;
        })
        .catch((error) => {
          this.loadingTable = false;
          console.log(error);
        });
    },
    showConfirmBatchDelete(id) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title:
            "<strong style='font-size : 24px; font-weight : 600;'>Apakah kamu yakin ingin menghapus Batch ini ?</strong>",
          icon: "warning",
          width: "32rem",
          html: `
            <div class="mt-3" style="max-width : 100%; font-size : 16px;">
              Semua unit akan kembali ke status Pending Declare
            </div>
          `,
          reverseButtons: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: `
            Ya, saya yakin!
          `,
          cancelButtonText: `
            Batalkan
          `,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.batchDeleteId = id;
            this.openModal("DeleteBatchReason");
          } else {
            console.log("Masuk situ");
          }
        });
    },
    validateReason() {
      this.$v.$touch();
      if (this.$v.$invalid || this.$v.deleteReason.$error) {
      } else {
        this.bacthDelete();
      }
    },
    closeDeleteBatchReasonModal(shoulReset = true) {
      this.deleteReason = "";
      $("#modalDeleteBatchReason").modal("hide");
      if (shoulReset) {
        this.$v.$reset();
      }
    },
    bacthDelete() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      const payload = {
        batchId: this.batchDeleteId,
        action: "deleted",
        deletedReason: this.deleteReason,
      };
      this.$http
        .post(process.env.ROLEBACK_BATCH_INSURANCE, payload, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.status == 200 && response.data.status == 200) {
            this.getListBatchInsurance();
            this.closeDeleteBatchReasonModal();
            swalWithBootstrapButtons
              .fire({
                title: "Success",
                text: `Batch berhasil dihapus`,
                icon: "success",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          } else {
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          }
        })
        .catch((error) => {
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    downloadProvenFile(data) {
      console.log(data);
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      const payload = {
        batchId: data.id,
      };
      this.$http
        .post(process.env.BATCH_INSURANCE_LIST_DOCUMENTS, payload, {
          responseType: "blob",
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.status === 200) {
            const responseData = response.data;
            const url = URL.createObjectURL(responseData);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Bukti-Deklarasi-${data.label}.zip`;
            a.target = "_blank";
            a.click();
            a.remove();
          } else {
            swalWithBootstrapButtons
              .fire({
                title: "Failed",
                text: `${response.data.message}`,
                icon: "error",
              })
              .then((result) => {
                if (result.isConfirmed) {
                }
              });
          }
        })
        .catch((error) => {
          swalWithBootstrapButtons
            .fire({
              title: "Failed",
              text: `${error.response.data.message}`,
              icon: "error",
            })
            .then((result) => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            });
        });
    },
    sendLog(w, x) {
      // var today = new Date();
      // var month = today.getMonth()+1
      // if (month < 10) {
      //     month = '0'+month
      // }
      // var dateDay = today.getDate()
      // if (dateDay < 10) {
      //     dateDay = '0'+dateDay
      // }
      // var hours = today.getHours()
      // if (hours < 10) {
      //     hours = '0'+hours
      // }
      // var minutes = today.getMinutes()
      // if (minutes < 10) {
      //     minutes = '0'+minutes
      // }
      // var second = today.getSeconds()
      // if (second < 10) {
      //     second = '0'+second
      // }
      // var date = today.getFullYear()+'-'+month+'-'+dateDay;
      // var time = hours + ":" + minutes + ":" + second;
      // var dateTime = date+' '+time;
      // var admin = this.admin
      // var command = 'add-logs'
      // // var productName = this.productNameChoose
      // this.$http.post(process.env.LOG_URL+"/company/"+x,{
      //     codeLogs: w,
      //     params: [],
      // },{
      //     headers: {'Asani-Token':localStorage.getItem('jwt')}
      // })
      // .then(response => {
      // })
      // .catch(error => {
      //     console.log(error)
      // })
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    toDataPage(pagePost) {
      this.$router.push({
        path: "/insurance/batch",
        query: {
          page: pagePost,
          itemPerPage: 10,
          batchOrder: this.searchBatchOrder,
          partnerName: this.searchPartnerName,
          status: this.searchStatus,
          startDateDeclare: this.searchStartDateDeclare,
          endDateDeclare: this.searchEndDateDeclare,
        },
      });
      location.reload();
      // this.getData();
    },
    setQuery() {
      this.$router.push({
        path: "/insurance/batch",
        query: {
          page: 1,
          itemPerPage: this.itemPerPage,
          batchOrder: this.searchBatchOrder,
          partnerName: this.searchPartnerName,
          status: this.searchStatus,
          startDateDeclare: this.searchStartDateDeclare,
          endDateDeclare: this.searchEndDateDeclare,
        },
      });
      // location.reload();
      // this.getData();
    },
    resetFilter() {
      this.$router.push({
        path: "/insurance/batch",
        query: {
          page: 1,
          itemPerPage: 10,
          batchOrder: "",
          partnerName: "",
          status: "",
          startDateDeclare: "",
          endDateDeclare: "",
        },
      });
      // location.reload();
    },
    setFilterData() {
      this.searchBatchOrder = this.$route.query.batchOrder;
      this.searchPartnerName = this.$route.query.partnerName;
      this.searchStatus = this.$route.query.status;
      this.searchStartDateDeclare = this.$route.query.startDateDeclare;
      this.searchEndDateDeclare = this.$route.query.endDateDeclare;
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    openModal(modalName) {
      $("#modal" + modalName).modal("show");
    },
    dateFormat($date) {
      const d = new Date($date);
      if (d.getDate().toString().length == 1) {
        var date = "0" + d.getDate().toString();
      } else {
        date = d.getDate();
      }
      if ((d.getMonth() + 1).toString().length == 1) {
        var month = "0" + (d.getMonth() + 1).toString();
      } else month = d.getMonth() + 1;
      return date + "-" + month + "-" + d.getFullYear();
    },
    cekPermission() {
      this.permission = JSON.parse(localStorage.getItem("roles"));
      if (this.permission.indexOf("22.3") < 0) {
        this.$router.push("/");
      }
    },
  },
  created() {
    const allPermission = JSON.parse(localStorage.getItem("roles"));
    this.cancelInsurancePermission =
      allPermission && allPermission.indexOf("15.2") >= 0;
    this.selectInsurance = localStorage.getItem("selectInsurance")
      ? JSON.parse(localStorage.getItem("selectInsurance"))
      : [];
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.getListBatchInsurance();
    this.setFilterData();
    this.cekPermission();
  },
  // computed: {
  //   reversedMessage: function () {
  //     localStorage.setItem('selectInsurance', this.selectInsurance)
  //     return ''
  //   }
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.total-data {
  margin-top: 7px;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797fb;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797fb;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797fb;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.one-line {
  display: flex;
  margin: 5px 0px;
}

.border-red {
  border-color: red;
}

.one-line .ol-label.storage {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-roles {
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.stPrice-sch {
  width: 186px;
  margin: 7px 0px;
}

.delivery-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}

.input-group-addon {
  padding: 7px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  margin: 0px 0px 0px 0px;
  height: fit-content;
}

.label-addon-rp {
  margin: 5px 0px;
}

.modal-lg,
.modal-xl {
  max-width: 1200px;
}

td,
tr {
  text-align: center;
}

.btn-action {
  border-radius: 0.6rem;
}

.btn-action-download {
  border-color: rgba(151, 203, 251, 0.5);
}
.btn-action-trash {
  border-color: rgba(255, 52, 68, 0.5);
}

.btn-action-download:hover {
  background-color: rgba(151, 203, 251, 1);
}
.btn-action-trash:hover {
  background-color: rgba(255, 52, 68, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/BatchInsurancePage.vue